import { ObservableFromFetch } from "../ObservableFromFetch"
import TimeZoneData from "./Model/TimeZoneData"

export default function TimeZoneListGet() {
  return ObservableFromFetch<TimeZoneData[]>("Order/GetTimeZones")
}